import type { AxiosResponse } from "axios";
import type { Moment } from "moment";

import type {
  CancelableAxiosPromise,
  S3PutSuccess,
} from "cortex/ui/src/service/base";
import { baseService } from "cortex/ui/src/service/base";

export const deploymentService = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/deployments");
  },

  loadScheduled(): CancelableAxiosPromise {
    return baseService.get("/api/scheduled-deployments");
  },

  // eslint-disable-next-line max-params
  schedule(
    strategyId: string | number,
    targetIds: Array<string | number>,
    deployDate: Moment | string,
    endDate: Moment | string,
    deployNow: boolean,
  ): CancelableAxiosPromise {
    return baseService.post("/api/scheduled-deployment", {
      deployDate,
      deployNow,
      endDate,
      strategyId,
      targetIds,
    });
  },

  // eslint-disable-next-line max-params
  edit(
    deploymentId: number,
    strategyId: string | number,
    targetIds: Array<string | number>,
    deployDate: Moment | string,
    endDate: Moment | string,
    deployNow: boolean,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/scheduled-deployment", {
      deploymentId,
      deployDate,
      deployNow,
      endDate,
      strategyId,
      targetIds,
    });
  },

  delete(deploymentId: number): CancelableAxiosPromise {
    return baseService.delete("/api/scheduled-deployment", { deploymentId });
  },
};

export default deploymentService;
